; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('sageBootstrap',["jquery", "scorebootstrap", "eventManager", "SageDotCom/Utility/sanitizer", 'promise-polyfill'], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("scorebootstrap"), require("eventManager"), require("/SageDotCom/Utility/sanitizer")) :
            console && console.error('Sage BootstrapUI does not support non-amd script loading.');
}(this/* window */, function ($, scorebootstrap, eventManager, sanitizer) {

    window.BrainJocks = window.BrainJocks || scorebootstrap;

    BrainJocks.BootstrapUI.TabSet.TabSetIsAccordion = function ($button) {
        if (!$button) {
            return false;
        }
        if (BrainJocks.BootstrapUI.Settings.hasParentWithSelector($button, ".score-accordion")) {
            return true;
        }
        if (BrainJocks.BootstrapUI.Settings.hasParentWithSelector($button, ".tabAccordion-panel-accordion")) {
            return true;
        }
        return false;
    }

    BrainJocks.BootstrapUI.Settings.hasParentWithSelector = function (childElement, selector) {
        if (!childElement) {
            return false;
        }

        var domElement = (typeof jQuery !== 'undefined' && childElement instanceof jQuery)
            ? childElement[0]
            : childElement;

        if (!domElement) {
            return false;
        }
    }

    BrainJocks.BootstrapUI.Settings.hiddenClassList = function () {
        return ['hidden-xs', 'hidden-sm', 'hidden-md', 'hidden-lg'];
    }

    BrainJocks.BootstrapUI.TabSet.init = function () {
        if ($("body").hasClass("mode-live") || $("body").hasClass("mode-preview")) {
            $('.score-tab').each(function () {
                var tabComponent = $(this);
                var tabsNav = tabComponent.find('.nav').first();
                var tabsContent = tabComponent.find('.tab-content').first();
                tabsNav.empty();

                //Create a document fragment to store the list items, this will avoid multiple DOM operations and repaints
                var fragment = document.createDocumentFragment();

                tabsContent.children('.tab-pane').each(function () {
                    var tabPane = $(this);
                    var tabId = tabPane.prop('id');
                    var tabIcon = tabPane.data('icon');
                    var tabAlt = (tabPane.data('alt') || "").trim();
                    var tabTitle = tabPane.data('title');
                    var tabDescription = tabPane.data('description');
                    var anchorable = /^(true|1|yes)$/i.test(tabPane.data('anchorable') || "");
                    var panelName = tabPane.data("panel-name");
                    var eventMessages = tabPane.data("event-messages");

                    tabPane.attr("aria-labelledby", tabId + "-tab").attr("role", "tabpanel");

                    var listItem = $('<span>',
                        {
                            class: BrainJocks.BootstrapUI.TabSet.getHiddenClasses(this) + " nav-tab"
                        }).append($('<button>',
                        {
                            href: '#' + tabId,
                            'aria-controls': tabId,
                            role: 'tab',
                            'data-toggle': 'tab',
                            'data-anchorable': anchorable,
                            'data-panel-name': panelName,
                            'data-event-messages': eventMessages,
                            class: "nav-tab-btn",
                            id: tabId + "-tab",
                            tabindex: -1
                        }).append(tabIcon
                        ? $('<img>',
                            {
                                class: 'lazy',
                                'data-src': tabIcon,
                                alt: tabAlt
                            })
                        : '',
                        $('<div>').append(tabDescription ? $('<div>').addClass("tabTitle").text(tabTitle) : tabTitle,
                            tabDescription ? $('<p>').text(tabDescription) : '')
                        ));
                    fragment.appendChild(listItem[0]);
                });

                //Append the document fragment to the DOM, once all the list items are added
                tabsNav.append(fragment);

                tabComponent.on("click touch",
                    ".nav-tab-btn",
                    function (index, buttonEl) {
                        //Set clicked button to active, and other ones to inactive
                        BrainJocks.BootstrapUI.showTab($(this).closest('.nav-tab'));
                    });

                //Attach event handlers
                var accordionClickFunc = function (event) {
                    var expanded = $(event.currentTarget).attr('aria-expanded');
                    var parent = $(event.currentTarget).closest(".tabAccordion-panel-accordion");
                    if (expanded === 'false') {
                        parent.addClass("active");
                    }
                    else {
                        parent.removeClass("active");
                    }
                    setTimeout(() => {
                        // ensure to only apply aria-expanded on control
                        parent.find(".collapse").removeAttr("aria-expanded");
                    }, 1000);
                };

                tabsNav.find('button[data-toggle="collapse"]').on('click', accordionClickFunc);

                new Promise(function (resolve, reject) {
                    var accPlaceholder = tabComponent.find('.tabAccordion-accordion');
                    var tabAccordionPanelList = tabComponent.find('.tabAccordion-panel-tabSet');
                    var tabAccordionHTML = '';

                    tabsContent.children('.tabAccordion-panel-accordion').each(function (index) {
                        var tabAccordion = $(this);
                        var sourceTab = tabAccordionPanelList.get(index);

                        $(sourceTab).children().each(function (childIndex) {
                            var tabAccordionPanelBody = this.cloneNode(true);
                            tabAccordion.find('.panel-body').append(tabAccordionPanelBody);


                            // do not duplicate score brightcove component as it causes errors with the player.
                            // video will be manually moved between the accordion and tabset on resize (in frontend.js) when needed
                            $(tabAccordionPanelBody).find(".score-brightcove-video").remove();
                            
                        });

                        if (index === 0) {
                            tabAccordion.addClass("active");
                            tabAccordion.find(".collapse").addClass("in");
                        }

                        tabAccordionHTML += tabAccordion.prop('outerHTML');
                    });

                    accPlaceholder.html(tabAccordionHTML);

                    //Remove old tabAccordion panels

                    tabComponent.find(".tabAccordion-tabSet .tabAccordion-panel-accordion").remove();

                    $(".tabAccordion-accordion [href^='#']", tabComponent).on('click', accordionClickFunc);

                    // Move panel descriptions to within the panel body when accordion is in desktop mode
                    if (tabComponent.hasClass("accordion-in-desktop")) {
                        var accordionPanels = tabComponent.find(".tabAccordion-panel-accordion");
                        accordionPanels.each(function() {
                            var panel = $(this);
                            var panelDescription = panel.find(".panel-desc");
                            var panelBody = panel.find(".panel-body");
                            panelBody.prepend(panelDescription);
                        });
                    } 

                    // Clone the Call To Action (CTA) to within the tab accordion if it's a "suites-tabset"
                    if (tabComponent.hasClass("suites-tabset")) {
                        var cta = tabComponent.find(".tabset-ctas.score-call-to-action");
                        var sectionHeader = tabComponent.find("h2.tabset-section-header");
                        var sectionBody = sectionHeader.next(); //Using .next() to get the immediate sibling of the section header, before it was taking <p> tags from within the panel body

                        if (cta.length > 0) { 
                            var ctaClone = cta.clone();
                            accPlaceholder.append(ctaClone);
                        }

                        //Confirm the sectionbody exists and .next() didn't return anything other than an immediate <p> sibling
                        if (sectionBody.length > 0 && sectionBody.prop('tagName').toLowerCase() === "p") {
                            var sectionBodyClone = sectionBody.clone();
                            accPlaceholder.prepend(sectionBodyClone);
                        }
                        if (sectionHeader.length > 0) {
                            var sectionHeaderClone = sectionHeader.clone();
                            accPlaceholder.prepend(sectionHeaderClone);
                        }
                    }

                    //Correct tab body content ID's
                    $(".tabAccordion-accordion").each(function () {
                        var container = $(this);
                        container.find("[id]").each(function (index, el) {
                            var newId = el.id + "-mobile";
                            var links = container.find("[href='#" + el.id + "']");
                            if (links.length > 0) {
                                links.attr("href", "#" + newId);
                                links.attr("aria-controls", newId);
                            }
                            el.id = newId;
                        });
                    });

                    resolve();
                }).catch(function (error) {
                    console.error('An error occurred:', error);
                });
                tabsContent.children('.tab-pane').each(function () {
                    var tabPane = $(this);
                    var tabId = tabPane.prop('id');
                    //strip the id
                    var tabGuid = tabId.slice(4)
                    //add copilot gradient class to any nav tab that has the style applied to corresponding tab pane
                    if (tabPane.hasClass("active-tab-gradient")) {
                        $('.nav-tabs-wrapper-outer').find("button[href='#" + tabId + "']").addClass("active-tab-ai-gradient");
                        // also add to tabAccordion-accordion panels
                        $('.tabAccordion-accordion').find("button[href='#collapse-" + tabGuid + "-mobile']").addClass("active-tab-ai-gradient");
                    };
                });
            });
        }
    }

    

    BrainJocks.BootstrapUI.TabSet.activate = function () {
        eventManager.subscribe("query-string-change",
            function(qs) {
                try {
                    if (sanitizer.containsHTML(qs)) {
                        if (window.enableLogging) {
                            console.error("SAGE DEBUG: Querystring contains html, ignoring");
                        }
                        return;
                    }

                    const testUrl = new URL(window.location.pathname + qs, window.location.origin);
                    testUrl.searchParams.forEach(function(val, param) {
                        const tabset = $('.score-tab[data-tabset-name=' + param + ']');
                        if (tabset.length > 0) {
                            const tabToOpen =
                                tabset.find(".nav .nav-tab button[data-panel-name='" + val + "']");

                            if (tabToOpen.length > 0) {
                                tabToOpen[0].click();
                            }
                        }
                    });
                } catch (ex) {
                    //if querystring is invalid, or any other error, fail graciously
                    if (window.enableLogging) {
                        console.error("SAGE DEBUG: Querystring exception: ", ex);
                    }
                }
            });

        $('.score-tab').each(function () {
            const tabset = $(this);
            const nav = tabset.find(".nav-tabs-wrapper-inner");
            const navUl = nav.find(".nav-tabs");
            const tabsetName = tabset.attr("data-tabset-name");
            const tabToOpen = tabsetName ? new URLSearchParams(window.location.search).get(tabsetName) : null;

            // Check if slick is not initialized to prevent resetting on resize
            if (!navUl.hasClass("slick-initialized")) {
                const defaultTab = tabset.find('.nav .nav-tab button')[0]; // first tab as default for first load
                const pageLoadTab = tabToOpen ? tabset.find(".nav .nav-tab button[data-panel-name='" + tabToOpen + "']")[0] : undefined; //tab selected via querystring
                const currActiveTab = tabset.find('.nav .nav-tab.active button')[0]; // current active tab to be used on resize
                let tabToActivate = currActiveTab || pageLoadTab || defaultTab;

                if (BrainJocks.BootstrapUI.Utils.isDeepLinked()) {
                    const anchor = BrainJocks.BootstrapUI.Utils.getAnchor();
                    tabToActivate = tabset.find("button[href='#tab-" + anchor + "']")[0] || tabToActivate;
                }

                var ariaAttr = BrainJocks.BootstrapUI.TabSet.TabSetIsAccordion(tabToActivate) ? "aria-expanded" : "aria-selected";
                tabset.find('.nav .nav-tab .nav-tab-btn').attr(ariaAttr, "false");

                //manual workaround due to CMS-958
                if (!currActiveTab) {
                    $(tabset.find('.nav .nav-tab')[0]).addClass("active");
                } else {
                    $(currActiveTab).attr(ariaAttr, "true");
                }

                BrainJocks.BootstrapUI.showTab(tabToActivate);
            }
        });
    };


    BrainJocks.BootstrapUI.TabSet.getHiddenClasses = function (tabPane) {
        var classList = tabPane.className;
        return BrainJocks.BootstrapUI.Settings.hiddenClassList().filter(function (value) {
            return new RegExp('(^| )' + value + '( |$)').test(classList);
        }).join(" ");
    }

    BrainJocks.BootstrapUI.showTab = function (tabElement) {
        var $this = $(tabElement);
        var $ul = $this.closest('.nav-tabs:not(.dropdown-menu)');
        var selector = $this.data('target');

        if (!selector) {
            selector = $this.attr('href');
            if (selector !== undefined) {
                selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
            }
        }

        if ($ul.length !== 0) {
            $ul.find(".nav-tab-btn").attr("tabindex", "-1").addClass("bypasstabindex");
            if ($this.hasClass("nav-tab-btn")) {
                $this.attr("tabindex", "0");
            }
            else {
                $this.find(".nav-tab-btn").attr("tabindex", "0")
            }
        }

        var slider = $this.closest(".slick-slide");
        if (slider.length > 0) {
            var slideEl = slider.get(0);
            if (slideEl) {
                //slideEl.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
                window.setTimeout(function () {
                    var offset = slider.offset().left;
                    if (offset !== 0 && (offset > 1 || offset < -1)) {
                        //even with scroll into view, still not in view
                        //need to extract the x value from the translate 3d
                        var transform = slider.closest(".slick-track").css("transform").replace(/[^0-9\-.,]/g, '').split(",");
                        if (transform.length > 0) {
                            var translateX = Number(transform[12] || transform[4]);
                            if (translateX !== 0) {
                                var newLeft = translateX - slider.offset().left;
                                slider.closest(".slick-track").css("transition", "transform ease 500ms");
                                slider.closest(".slick-track").css("transform", "translate3d(" + newLeft + "px, 0, 0)");
                            }
                        }
                    }
                }, 500);
            }
        }

        if ($this.parent('.nav-tab').hasClass('active')) {
            if(selector !== "") {
                var tabPanel = $(selector);
                if (!tabPanel.hasClass("active")) {
                    //show the relevant panel
                    if($this.attr("aria-selected") === "false") {
                        $this.attr("aria-selected", "true");
                    }
                    if ($this.attr("aria-expanded") === "false") {
                        $this.attr("aria-expanded", "true");
                    }
                    tabPanel.addClass("active");
                    tabPanel.siblings("active").removeClass("active");
                }
            }
            return;
        }

        
        var $previous = $ul.find('.active:last button');
        var hideEvent = $.Event('hide.bs.tab',
            {
                relatedTarget: $this[0]
            });
        var showEvent = $.Event('show.bs.tab',
            {
                relatedTarget: $previous[0]
            });

        $previous.trigger(hideEvent);
        $this.trigger(showEvent);

        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;

        var $target = $(selector);

        BrainJocks.BootstrapUI.activateTab($this.closest('.nav-tab'), $ul);
        BrainJocks.BootstrapUI.activateTab($target,
            $target.parent(),
            function() {
                $previous.trigger({
                    type: 'hidden.bs.tab',
                    relatedTarget: $this[0]
                });
                $this.trigger({
                    type: 'shown.bs.tab',
                    relatedTarget: $previous[0]
                });
            });
    }

    BrainJocks.BootstrapUI.activateTab = function (element, container, callback) {
        var $active = container.find('> .active');
        var ariaAttr = BrainJocks.BootstrapUI.TabSet.TabSetIsAccordion(element) ? "aria-expanded" : "aria-selected";
        var transition = callback &&
            $.support.transition &&
            ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);

        function next() {
            $active
                .removeClass('active')
                .find('> .dropdown-menu > .active')
                .removeClass('active')
                .end()
                .find('[data-toggle="tab"]')
                .attr(ariaAttr, false);

            element
                .addClass('active')
                .find('[data-toggle="tab"]')
                .attr(ariaAttr, true);

            if (transition) {
                element[0].offsetWidth; // reflow for transition
                element.addClass('in');
            } else {
                element.removeClass('fade');
            }

            if (element.parent('.dropdown-menu').length) {
                element
                    .closest('.nav-tab.dropdown')
                    .addClass('active')
                    .end()
                    .find('[data-toggle="tab"]')
                    .attr(ariaAttr, true);
            }

            callback && callback();
        }

        $active.length && transition
            ? $active
            .one('bsTransitionEnd', next)
            .emulateTransitionEnd(Tab.TRANSITION_DURATION)
            : next();

        $active.removeClass('in');
    }

    return BrainJocks.BootstrapUI;
}));

